module.exports = __webpack_public_path__ + "img/Visa.e4d4ceca.svg";